import React from 'react';
import PropTypes from 'prop-types';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material';

function NestedNavigationItem({
  nestedItem,
  classes,
  handleChangePage
}) {
  return (
    <ListItemButton
      key={nestedItem.id}
      onClick={() => handleChangePage(nestedItem)}
    >
      <ListItemIcon>
        <span
          className={`${nestedItem.icon} ${classes.navigationIconFA}`}
        />
      </ListItemIcon>
      <ListItemText
        inset
        primary={nestedItem.text}
        primaryTypographyProps={{ style: { color: 'white ' } }}
      />
    </ListItemButton>
  );
}

NestedNavigationItem.propTypes = {
  nestedItem: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  }).isRequired,
  classes: PropTypes.shape({
    navigationIconFA: PropTypes.string.isRequired
  }).isRequired,
  handleChangePage: PropTypes.func.isRequired
};

export { NestedNavigationItem };
